import $ from 'jquery';

const fieldWrapper = () => {
    $('.Form__Element select').wrap('<div class="select-wrapper"><div class="input-wrapper"></div></div>');
};

$(() => {
    fieldWrapper();
});
